const LEAD_SCORING_QUERY_KEY = 'leadScoring';

export const leadScoringQueryKey = {
  summary: (companyDomain: string, score: string, triggeredSignalsIds: string[]) =>
    [LEAD_SCORING_QUERY_KEY, companyDomain, score, triggeredSignalsIds.join(',')] as const,
};
